import { toJalaliDate } from "../../../../../middleware/middleware";

export const formatMoney = (value) => {
  if (value == null || value === "") return "—";
  return Number(value).toLocaleString("fa-IR");
};

export const formatPercent = (value) => {
  if (value == null) return "—";
  return `${Number(value).toLocaleString("fa-IR")}٪`;
};

export const formatDateTime = (value) => (value ? toJalaliDate(value) : "—");

export const buildSearchPayload = (filterValues) => ({
  mobile: filterValues.mobile?.trim() || null,
  messageId: filterValues.messageId ? parseInt(filterValues.messageId, 10) : null,
  requestId: filterValues.requestId ? parseInt(filterValues.requestId, 10) : null,
  referenceId: filterValues.referenceId ? parseInt(filterValues.referenceId, 10) : null,
  smsType: filterValues.smsType?.trim() || null,
  purpose: filterValues.purpose?.trim() || null,
  status: filterValues.status ? parseInt(filterValues.status, 10) : null,
  internalStatus: filterValues.internalStatus?.trim() || null,
  providerStatus: filterValues.providerStatus?.trim() || null,
  minCost: filterValues.minCost ? parseInt(filterValues.minCost, 10) : null,
  maxCost: filterValues.maxCost ? parseInt(filterValues.maxCost, 10) : null,
  startDate: filterValues.startDate || null,
  endDate: filterValues.endDate || null,
  pageNumber: filterValues.pageNumber,
  pageSize: filterValues.pageSize,
});

export const getQuickDateRange = (preset) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const format = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day} 00:00:00`;
  };

  if (preset === "today") {
    return { startDate: format(today), endDate: format(today) };
  }
  if (preset === "yesterday") {
    const y = new Date(today);
    y.setDate(y.getDate() - 1);
    return { startDate: format(y), endDate: format(y) };
  }
  if (preset === "last7") {
    const start = new Date(today);
    start.setDate(start.getDate() - 6);
    return { startDate: format(start), endDate: format(today) };
  }
  if (preset === "thisMonth") {
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: format(start), endDate: format(today) };
  }
  return { startDate: "", endDate: "" };
};

export const getStatusChipColor = (internalKey, isQaBlocked) => {
  if (isQaBlocked || internalKey === "BlockedByQa") return "warning";
  if (internalKey === "Sent") return "success";
  if (internalKey === "Failed" || internalKey === "ProviderRejected") return "error";
  if (internalKey === "Pending" || internalKey === "ProviderAccepted") return "info";
  if (internalKey === "RateLimited") return "secondary";
  return "default";
};
